import { NAME } from './constants';

export const CHECK_DATA_EXPORT_STATUS = `${NAME}/CHECK_DATA_EXPORT_STATUS`;
export const CHECK_DATA_EXPORT_STATUS_SUCCESS = `${NAME}/CHECK_DATA_EXPORT_STATUS_SUCCESS`;
export const CHECK_DATA_EXPORT_STATUS_FAIL = `${NAME}/CHECK_DATA_EXPORT_STATUS_FAIL`;
export const INVALID_INPUT_VALUE = `${NAME}/INVALID_INPUT_VALUE`;
export const LOAD_CREATE_EXPORT = `${NAME}/LOAD_CREATE_EXPORT`;
export const LOAD_CREATE_EXPORT_SUCCESS = `${NAME}/LOAD_CREATE_EXPORT_SUCCESS`;
export const LOAD_CREATE_EXPORT_FAIL = `${NAME}/LOAD_CREATE_EXPORT_FAIL`;
export const LOAD_CREATE_EXPORT_FAIL_VALIDATION = `${NAME}/LOAD_CREATE_EXPORT_FAIL_VALIDATION`;
export const LOAD_CREATE_EXPORT_CLEAR_ERROR = `${NAME}/LOAD_CREATE_EXPORT_CLEAR_ERROR`;
export const LOAD_CREATE_EXPORT_QUOTE = `${NAME}/LOAD_CREATE_EXPORT_QUOTE`;
export const LOAD_CREATE_EXPORT_QUOTE_SUCCESS = `${NAME}/LOAD_CREATE_EXPORT_QUOTE_SUCCESS`;
export const LOAD_CREATE_EXPORT_QUOTE_FAIL = `${NAME}/LOAD_CREATE_EXPORT_QUOTE_FAIL`;
export const LOAD_EXPORT_FINAL_QUOTE = `${NAME}/LOAD_EXPORT_FINAL_QUOTE`;
export const LOAD_EXPORT_FINAL_QUOTE_SUCCESS = `${NAME}/LOAD_EXPORT_FINAL_QUOTE_SUCCESS`;
export const LOAD_EXPORT_FINAL_QUOTE_FAIL = `${NAME}/LOAD_EXPORT_FINAL_QUOTE_FAIL`;
export const LOAD_DATA_EXPORTS_FOR_USER = `${NAME}/LOAD_DATA_EXPORTS_FOR_USER`;
export const LOAD_DATA_EXPORTS_FOR_USER_SUCCESS = `${NAME}/LOAD_DATA_EXPORTS_FOR_USER_SUCCESS`;
export const LOAD_DATA_EXPORTS_FOR_USER_FAIL = `${NAME}/LOAD_DATA_EXPORTS_FOR_USER_FAIL`;
export const LOAD_DATA_EXPORT_TYPES = `${NAME}/LOAD_DATA_EXPORT_TYPES`;
export const LOAD_DATA_EXPORT_TYPES_SUCCESS = `${NAME}/LOAD_DATA_EXPORT_TYPES_SUCCESS`;
export const LOAD_DATA_EXPORT_TYPES_FAIL = `${NAME}/LOAD_DATA_EXPORT_TYPES_FAIL`;
export const UPDATE_AIRLINE_SELECT = `${NAME}/UPDATE_AIRLINE_SELECT`;
export const UPDATE_AIRPORT_SELECT = `${NAME}/UPDATE_AIRPORT_SELECT`;
export const UPDATE_SYNC_MULTISELECT = `${NAME}/UPDATE_SYNC_MULTISELECT`;
export const UPDATE_CHECKED_SEARCH = `${NAME}/UPDATE_CHECKED_SEARCH`;
export const PREV_EXPORTS_OPEN_OPTION = `${NAME}/PREV_EXPORTS_OPEN_OPTION`;
export const RESET_ALL_FORM_FIELDS = `${NAME}/RESET_ALL_FORM_FIELDS`;
export const CLEAR_PREVIOUS_QUOTE = `${NAME}/CLEAR_PREVIOUS_QUOTE`;
export const UPDATE_INPUT_VALUE = `${NAME}/UPDATE_INPUT_VALUE`;
export const VALIDATE_FORM_SUBMISSION = `${NAME}/VALIDATE_FORM_SUBMISSION`;
export const GET_SERVER_DATE = `${NAME}/GET_SERVER_DATE`;
export const GET_SERVER_DATE_SUCCESS = `${NAME}/GET_SERVER_DATE_SUCCESS`;
export const GET_SERVER_DATE_FAIL = `${NAME}/GET_SERVER_DATE_FAIL`;
export const SET_SAVED_STATE = `${NAME}/SET_SAVED_STATE`;
export const SET_EXPORT_TYPE = `${NAME}/SET_EXPORT_TYPE`;
export const CREATE_DATA_EXPORT_EVENT = `${NAME}/CREATE_DATA_EXPORT_EVENT`;
export const CREATE_DATA_EXPORT_EVENT_SUCCESS = `${NAME}/CREATE_DATA_EXPORT_EVENT_SUCCESS`;
export const CREATE_DATA_EXPORT_EVENT_FAIL = `${NAME}/CREATE_DATA_EXPORT_EVENT_FAIL`;
export const DELETE_DATA_EXPORT = `${NAME}/DELETE_DATA_EXPORT`;
export const DELETE_DATA_EXPORT_SUCCESS = `${NAME}/DELETE_DATA_EXPORT_SUCCESS`;
export const DELETE_DATA_EXPORT_FAIL = `${NAME}/DELETE_DATA_EXPORT_FAIL`;
export const REMOVE_DATA_EXPORT = `${NAME}/REMOVE_DATA_EXPORT`;
export const OPEN_DELETE_EXPORT_MODAL = `${NAME}/OPEN_DELETE_EXPORT_MODAL`;
export const CLOSE_DELETE_EXPORT_MODAL = `${NAME}/CLOSE_DELETE_EXPORT_MODAL`;
export const DISMISS_LIMITED_SEARCH = `${NAME}/DISMISS_LIMITED_SEARCH`;
export const SET_POLLING_STATUS = `${NAME}/SET_POLLING_STATUS`;
export const LOAD_REFRESH_EXPORTS = `${NAME}/LOAD_REFRESH_EXPORTS`;
export const LOAD_REFRESH_EXPORTS_SUCCESS = `${NAME}/LOAD_REFRESH_EXPORTS_SUCCESS`;
export const LOAD_REFRESH_EXPORTS_FAIL = `${NAME}/LOAD_REFRESH_EXPORTS_FAIL`;
export const RESET_PURCHASE_EXPORT_DATA = `${NAME}/RESET_PURCHASE_EXPORT_DATA`;
export const CLEAR_POLLING_EXPORT_ID = `${NAME}/CLEAR_POLLING_EXPORT_ID`;
export const DISMISS_QUOTE_REPROCESS = `${NAME}/DISMISS_QUOTE_REPROCESS`;
export const DISMISS_QUOTE_REPROCESS_FAIL = `${NAME}/DISMISS_QUOTE_REPROCESS_FAIL`;
export const UPDATE_TEXT_FIELD_VALUE = `${NAME}/UPDATE_TEXT_FIELD_VALUE`;
export const CLEAR_CREATE_EXPORT = `${NAME}/CLEAR_CREATE_EXPORT`;



// WEBPACK FOOTER //
// ./modules/DataExports/redux/actionTypes.js